/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Notifications_Message_Body_WasInputs */

const he_notifications_message_body_was = /** @type {(inputs: Notifications_Message_Body_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`היה ${i?.price}`)
};

const en_notifications_message_body_was = /** @type {(inputs: Notifications_Message_Body_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`was ${i?.price}`)
};

/**
* | output |
* | --- |
* | "was {price}" |
*
* @param {Notifications_Message_Body_WasInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_body_was = /** @type {((inputs: Notifications_Message_Body_WasInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Body_WasInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_body_was(inputs)
	return en_notifications_message_body_was(inputs)
});